var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled, css } from "../../../utils";
import Icon from '../../Icon';
var ValidateErrorIcon = styled(Icon.ValidateError)(function (_a) {
    var space = _a.theme.space;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 26px;\n    height: 26px;\n    min-width: 26px;\n    min-height: 26px;\n    vertical-align: middle;\n    float: left;\n    margin-top: ", ";\n    margin-right: ", ";\n  "], ["\n    width: 26px;\n    height: 26px;\n    min-width: 26px;\n    min-height: 26px;\n    vertical-align: middle;\n    float: left;\n    margin-top: ", ";\n    margin-right: ", ";\n  "])), space[1], space[1]);
});
export default ValidateErrorIcon;
var templateObject_1;
//# sourceMappingURL=ValidateErrorIcon.js.map